import { ThemeProvider, createTheme } from "@material-ui/core";
import React from "react";
import { BrowserRouter as Router } from "react-router-dom";

import AppProvider from "./config/AppProvider";
import TopLevelRoutes from "./screens";

const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 700,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },
});

export default function App({ rollbarInstance }: { rollbarInstance?: any }) {
  return (
    <React.StrictMode>
      <ThemeProvider theme={theme}>
        <AppProvider rollbarInstance={rollbarInstance}>
          <Router>
            <TopLevelRoutes />
          </Router>
        </AppProvider>
      </ThemeProvider>
    </React.StrictMode>
  );
}
